<template>
	<div class="page machines">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="navigation-icon self"><path d="M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z"></path></svg>
					<span class="navigation-title">{{machine.name}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main no-padding-top">
				<div id="tabs" data-tabs="3">
					<div class="tabs-inner">
						<router-link
							v-for="tb in tabs"
							:key="tb.name"
							:class="['tab', {active: currentTab == tb}, {enabled: tb.enabled}]"
							:to="{name: tb.target}"
						>
							<span class="title">{{tb.description}}</span>
						</router-link>
					</div>
				</div>
				<transition name="slide-up" mode="out-in" appear>
					<router-view :key="$route.params.id"/>
				</transition>
			</section>
		</transition>
	</div>
</template>

<script>
export default {
	data() {
		let tabs = [
			{
				name: 'tab-1',
				description: this.$t('general-settings'),
				target: 'machine-settings',
				enabled: true
			},
			{
				name: 'tab-2',
				description: this.$t('remote-control-settings'),
				target: 'machine-remote-control',
				enabled: true
			},
			{
				name: 'tab-3',
				description: this.$t('documents'),
				target: 'machine-documents',
				enabled: true
			},
		];
		return {
			tabs: tabs,

			newMachine: {
				name: '',
				serialNumber: '',
				machineTypeName: '',
				spindlesNumber: '',
				code: '',
			},
			password: '',
			machine: {},
			saveError: false,
		}
	},
	computed: {
		currentTab() {
			let self = this;
			return this.tabs.find(e => e.target === self.$route.name);
		}
	},
	created() {
		let self = this;
		axios.get(`/machines/${self.$route.params.id}`)
		.then((response) => {
			self.machine = {...response.data.response.machine};
			this.tabs[1].enabled = this.machine.remoteEnabled;
			self.newMachine = {...response.data.response.machine};
			// self.$storage.getItem(`machine-${self.machine.name}-password`)
			self.$storage.getItem(`customer-${self.$store.getters.getProfile.id}`)
			.then((response) => {
				let customer;
				try {
					customer = JSON.parse(response);
				} catch(e) {
					console.log(e);
				}
				if (customer != null && typeof customer[`machine-${self.machine.name}-password`] !== 'undefined') {
					let password = customer[`machine-${self.machine.name}-password`];
					self.password = password;
				} else {
					self.password = '';
				}
			})
			.catch((err) => {
				console.log(err);
				self.password = '';
			});
		})
		.catch(() => {
			self.$router.go(-1);
		});
	},
}
</script>

<style scoped>
</style>